var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64943 0.924728C4.64943 0.924728 0.337003 16.0452 0.117107 17.0182C-0.102894 17.9911 -0.250141 19.404 1.97967 20H16.9889C17.5753 20 17.6252 19.6853 17.7716 19.333C17.7716 19.333 21.4362 4.38254 21.6193 3.7435C21.8025 3.1054 21.2591 2.40772 21.2591 2.40772L19.5561 0.454892C19.5561 0.454892 19.145 0 18.6016 0C18.0581 0 6.42966 0.109562 5.63287 0.109562C4.83609 0.109562 4.6477 0.923826 4.6477 0.923826L4.64943 0.924728ZM8.15025 2.89686H15.3727L13.412 8.56343H6.18885L8.14958 2.89686H8.15025ZM2.29879 16.7411H15.0211L18.6148 3.09588C18.9014 2.00639 20.5466 2.44728 20.2591 3.53675L16.3333 18.4434H2.29881C1.17252 18.4434 1.17252 16.7404 2.29881 16.7404L2.29879 16.7411Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.a9e59dd9f6c8c7ce797ef6b77bd6d37e.svg";
export { ForwardRef as ReactComponent };